export default "__VITE_ASSET__CIn8ay9T__"